import Permissions from "Common/permissions/permissions";
import locale from "./permissionsTree.locale";
export default [
    {
        id: "workSpaces",
        text: locale.WORKSPACES,
        items: [
            { id: Permissions.WorkSpacesView.toString(), text: locale.WORKSPACES_VIEW },
            { id: Permissions.WorkSpacesEdit.toString(), text: locale.WORKSPACES_EDIT },
            { id: Permissions.WorkSpacesDelete.toString(), text: locale.WORKSPACES_DELETE }
        ]
    },
    {
        id: "projects",
        text: locale.PROJECTS,
        items: [
            { id: Permissions.ProjectsView.toString(), text: locale.PROJECTS_VIEW },
            { id: Permissions.ProjectsEdit.toString(), text: locale.PROJECTS_EDIT },
            { id: Permissions.ProjectsDelete.toString(), text: locale.PROJECTS_DELETE }
        ]
    },
    {
        id: "documents",
        text: locale.DOCUMENTS,
        items: [
            { id: Permissions.DocumentsView.toString(), text: locale.DOCUMENTS_VIEW },
            { id: Permissions.DocumentsEdit.toString(), text: locale.DOCUMENTS_EDIT },
            { id: Permissions.DocumentsDelete.toString(), text: locale.DOCUMENTS_DELETE }
        ]
    },
    {
        id: "summaryReports",
        text: locale.SUMMARY_REPORTS,
        items: [
            { id: Permissions.SummaryReportsView.toString(), text: locale.SUMMARY_REPORTS_VIEW },
            { id: Permissions.SummaryReportsEdit.toString(), text: locale.SUMMARY_REPORTS_EDIT },
            { id: Permissions.SummaryReportsDelete.toString(), text: locale.SUMMARY_REPORTS_DELETE }
        ]
    },
    {
        id: "methods",
        text: locale.METHODS,
        items: [
            { id: Permissions.MethodsView, text: locale.METHODS_VIEW },
            { id: Permissions.MethodsRun, text: locale.METHODS_RUN }
        ]
    },
    {
        id: "tasks",
        text: locale.TASKS,
        items: [{ id: Permissions.TasksView, text: locale.TASKS_VIEW }]
    },
    {
        id: "settings",
        text: locale.MODULE_SETTINGS,
        items: [
            {
                id: "users",
                text: locale.USERS,
                items: [
                    { id: Permissions.UsersView.toString(), text: locale.USERS_VIEW },
                    { id: Permissions.UsersEdit.toString(), text: locale.USER_EDIT },
                    { id: Permissions.UserSelfEdit.toString(), text: locale.USERS_SELF_EDIT },
                    { id: Permissions.UsersDelete.toString(), text: locale.USERS_DELETE }
                ]
            },
            {
                id: "roles",
                text: locale.ROLES,
                items: [
                    { id: Permissions.RolesView.toString(), text: locale.ROLES_VIEW },
                    { id: Permissions.RolesEdit.toString(), text: locale.ROLES_EDIT },
                    { id: Permissions.RolesDelete.toString(), text: locale.ROLES_DELETE }
                ]
            },
            {
                id: "connections",
                text: locale.SETTINGS,
                items: [
                    { id: Permissions.SettingsView.toString(), text: locale.SETTINGS_VIEW },
                    { id: Permissions.SettingsEdit.toString(), text: locale.SETTINGS_EDIT }
                ]
            },
            {
                id: "actionLog",
                text: locale.ACTION_LOG,
                items: [
                    { id: Permissions.ActionLogView.toString(), text: locale.ACTION_LOG_VIEW },
                    { id: Permissions.ActionLogEdit.toString(), text: locale.ACTION_LOG_EDIT }
                ]
            },
            {
                id: "ontologicalModel",
                text: locale.ONTOLOGICAL_MODEL,
                items: [
                    { id: Permissions.OntologicalModelView.toString(), text: locale.ONTOLOGICAL_MODEL_VIEW },
                    { id: Permissions.OntologicalModelEdit.toString(), text: locale.ONTOLOGICAL_MODEL_EDIT }
                ]
            },
            {
                id: "passwordPolicy",
                text: locale.PASSWORD_POLICY,
                items: [
                    { id: Permissions.PasswordPolicyView.toString(), text: locale.PASSWORD_POLICY_VIEW },
                    { id: Permissions.PasswordPolicyEdit.toString(), text: locale.PASSWORD_POLICY_EDIT }
                ]
            }
        ]
    }
];
